export const MenuList = [
	// Dashboard
	{
		title: "Dashboard",
		classsChange: "mm-title",
		iconStyle: <i className="la la-home"></i>,
		to: "dashboard",
		text: "dashboard",
	},
	// Admins
	{
		title: "Admins Management",
		classsChange: "mm-title",
		iconStyle: <i className="la la-user-shield"></i>,
		to: "admins",
		text: "admins",
	},
	// Rules
	{
		title: "Rules",
		classsChange: "mm-title",
		iconStyle: <i className="la la-shield"></i>,
		to: "rules",
		text: "rules",
	},
	// Categories
	{
		title: "Categories",
		classsChange: "mm-title",
		iconStyle: <i className="la la-cube"></i>,
		to: "categories",
		text: "categories",
	},
	// Products
	{
		title: "Products",
		classsChange: "mm-title",
		iconStyle: <i className="la la-cubes"></i>,
		to: "products",
		text: "products",
	},
	// Variant
	{
		title: "Variant",
		classsChange: "mm-title",
		iconStyle: <i className="flaticon-381-paperclip" />,
		to: "variant",
		text: "variant",
	},
	// Dynamic Variant
	{
		title: "Dynamic Variant",
		classsChange: "mm-title",
		iconStyle: <i className="flaticon-381-paperclip" />,
		to: "dynamic-variant",
		text: "dynamic_variant",
	},
	// Orders
	{
		title: "Orders",
		classsChange: "mm-title",
		iconStyle: <i className="la la-truck"></i>,
		to: "orders",
		text: "orders",
	},
	// Orders Guest
	{
		title: "Orders Guest",
		classsChange: "mm-title",
		iconStyle: <i className="la la-truck"></i>,
		to: "orders-guest",
		text: "orders_guest",
	},
	// Promo Codes
	{
		title: "Promo Codes",
		classsChange: "mm-title",
		iconStyle: <i className="la la-code"></i>,
		to: "promo-codes",
		text: "promo_codes",
	},
	// Users
	{
		title: "Users",
		classsChange: "mm-title",
		iconStyle: <i className="la la-users"></i>,
		to: "users",
		text: "users",
	},
	// Banners
	{
		title: "Banners",
		classsChange: "mm-title",
		iconStyle: <i className="la la-photo"></i>,
		to: "banners",
		text: "banners",
	},
	// Style Up
	{
		title: "Style Up",
		classsChange: "mm-title",
		iconStyle: <i className="la la-photo"></i>,
		to: "style-up",
		text: "style_up",
	},

	// Home
	// {
	//     title:'Home',
	//     text:'home',
	//     classsChange: 'mm-collapse',
	//     iconStyle: <i className="la la-slack" />,
	//     content : [
	//         {
	//             title:'Page',
	//             text:'page',
	//             to: 'home/page',
	//             rule: 'home',
	//         },
	//         {
	//             title:'Products',
	//             text:'products',
	//             to: 'home/products',
	//             rule: 'home',
	//         },
	//         {
	//             title: "Social Media",
	//             text: "social_media",
	//             to: "home/social",
	//             rule: "home",
	//           },
	//         {
	//           title: "Contact Us",
	//           text: "contact_us",
	//           to: "home/contact-us",
	//           rule: "home",
	//         },
	//         {
	//           title: "About Us",
	//           text: "about_us",
	//           to: "home/about-us",
	//           rule: "home",
	//         },
	//     ]
	// },
	// MasterHN
	{
		title: "Setting",
		text: "setting",
		classsChange: "mm-collapse",
		iconStyle: <i className="la la-cog" />,
		content: [
			{
				title: "Social Media",
				text: "social_media",
				to: "social",
				rule: "masterHN",
			},
			{
				title: "Contact Us",
				text: "contact_us",
				to: "contact-us",
				rule: "home",
			},
			{
				title: "Delivery",
				text: "delivery",
				to: "delivery",
				rule: "masterHN",
			},
			{
				title: "Payment",
				text: "payment",
				to: "payment",
				rule: "masterHN",
			},
			{
				title: "About Us",
				text: "about_us",
				to: "pages/about-us",
				rule: "masterHN",
			},
		],
	},
	// Social Media
	// {
	//   title: "Social Media",
	//   classsChange: "mm-collapse",
	//   iconStyle: <i className="la la-wrench"></i>,
	//   to: "home/social",
	//   text: "social_media",
	// },

	// <i className='la la-cubes'></i>,
	// <i className='la la-cube'></i>,
	// <i className="la la-slack" />,
	// <i className="flaticon-381-notepad" />,
	// <i className="la la-qrcode"></i>
	// <i className='la la-truck'></i>
	// <i className='la la-pie-chart'></i>
	// <i className='la la-dollar'></i>
	// <i className="la la-wrench" />
	// <i className="la la-simplybuilt" />
	// <i className='la la-bell'></i>
];
